import React from 'react';
import Modal from 'react-bootstrap/Modal';
import { Spinner } from 'react-bootstrap';

interface IDeleteModal {
  show: boolean;
  onHide: () => void;
  onDelete: (id: any) => void;
  id: any;
  buttonType?: string;
  label?: string;
  isLoading?: boolean;
}

const DeleteModal: React.FC<IDeleteModal> = ({
  show,
  onHide,
  onDelete,
  id,
  buttonType = 'Delete',
  label = 'delete',
  isLoading = false,
}) => {
  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Body>
        <Modal.Title>Are you sure you want to {label}?</Modal.Title>
        <div className="d-flex justify-content-end gap-2 mt-3">
          <button
            type="button"
            className="btn-app btn-app--outline"
            onClick={onHide}
            disabled={isLoading}
          >
            Cancel
          </button>
          <button
            type="button"
            className="btn-app btn-app--danger"
            onClick={() => onDelete(id)}
            disabled={isLoading}
          >
            {isLoading ? <Spinner size="sm" /> : buttonType}
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default DeleteModal;
